import React from 'react';
import { LinearProgress } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { RootStoreModel } from '../../../redux';

export const Loading: React.FC = () => {
  const isLoading = useSelector(
    (state: RootStoreModel) => state.notifications && state.notifications.isLoading
  );
  return isLoading ? <LinearProgress /> : <></>;
};
